import React from 'react'
import styles from './CheckCase.module.scss'
import { JWayIcon } from '../../../assets/JWayIcons';

export interface CheckCaseProps {
    isChecked?: boolean;
    isIndeterminate?: boolean;
    onClick?: React.MouseEventHandler<HTMLDivElement> | undefined
}

export default function CheckCase({isChecked, isIndeterminate, onClick}: CheckCaseProps) {

  const getCheckState = () => {
    if (isIndeterminate) return 'indeterminate';
    if (isChecked) return 'checked';
    return 'unchecked';
  }

  const checkState = getCheckState();

  return (
    <div onClick={onClick} className={[
      styles['check-case-container'],
      checkState === 'checked' ? styles['check-case-container--checked'] : "",
      checkState === 'indeterminate' ? styles['check-case-container--indeterminate'] : ""
    ].join(" ")}>
      <div className={[
        styles['check-case-container__icon'],
        checkState === 'checked' ? styles['check-case-container__icon--checked'] : "",
        checkState === 'indeterminate' ? styles['check-case-container__icon--indeterminate'] : ""
      ].join(" ")}>
        {checkState === 'indeterminate' ? (
          <div style={{width: '8px', height: '2px', backgroundColor: 'white', borderRadius: '1px'}} />
        ) : (
          <JWayIcon type={"check-valid"} size={14} color='white'/>
        )}
      </div>
    </div>
  )
}


